import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import './Servicii.css';
import Footer from '../components/Footer';
import { FaGear,FaTruckFront } from "react-icons/fa6";
import { FaCarSide,FaCompressAlt } from "react-icons/fa";
import { RiEBikeFill } from "react-icons/ri";
import { IoDocumentTextOutline } from "react-icons/io5";
import { AiFillThunderbolt } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { TbTarget } from "react-icons/tb";
import { FaRegLightbulb } from "react-icons/fa";
import { Helmet } from 'react-helmet';


const Servicii = () => {
  const [activeService, setActiveService] = useState(null);

  const servicii = [
    {
      id: 1,
      icon: <FaGear />,
      title: "Inspecție Tehnică Periodică (ITP)",
      subtitle: "Verificare completă a vehiculului",
      description: "Efectuăm inspecția tehnică periodică conform normelor RAR în vigoare, cu echipamente moderne și personal autorizat.",
      details: [
        "Verificarea sistemului de frânare (eficiența, echilibrul, starea componentelor)",
        "Controlul sistemului de direcție și suspensii",
        "Testarea sistemului de iluminat și semnalizare",
        "Verificarea anvelopelor și roților",
        "Controlul emisiilor poluante (Euro 4, Euro 5, Euro 6)",
        "Verificarea sistemului de eșapament",
        "Controlul câmpului vizual și oglinzilor",
        "Testarea sistemului de încălzire și ventilație"
      ],
      durata: "30-45 minute",
      garantie: "Certificat ITP valabil conform legislației"
    },
    {
      id: 2,
      icon: <FaCarSide />,
      title: "ITP Autoturisme",
      subtitle: "Servicii dedicate mașinilor personale",
      description: "Inspecție specializată pentru autoturisme, cu atenție deosebită la confortul și siguranța șoferului.",
      details: [
        "Verificare completă a motorului și sistemelor auxiliare",
        "Testare computerizată a sistemului de frânare",
        "Controlul sistemului ABS și ESP (dacă este cazul)",
        "Verificarea sistemului de climatizare",
        "Testarea luminilor (mari, mici, ceață, semnalizare)",
        "Controlul benzilor de rulare și adâncimea profilului",
        "Verificarea sistemului de securitate (centuri, airbag-uri)",
        "Testarea emisiilor conform standardului Euro"
      ],
      durata: "30-40 minute",
      garantie: "Fișă de verificare detaliată + certificat ITP"
    },
    {
      id: 3,
      icon: <RiEBikeFill />,
      title: "ITP Motociclete & ATV",
      subtitle: "Specialiști în vehicule pe două roți",
      description: "Personal specializat în verificarea motocicletelor, scuterelor și ATV-urilor, cu echipamente adaptate.",
      details: [
        "Verificarea sistemului de frânare față și spate",
        "Controlul sistemului de direcție și furci",
        "Testarea suspensiilor și amortizorilor",
        "Verificarea anvelopelor și presiunii",
        "Controlul sistemului de iluminat specific",
        "Testarea sistemului de evacuare și zgomot",
        "Verificarea oglinzilor și sistemelor de semnalizare",
        "Controlul documentelor și numerelor de identificare"
      ],
      durata: "20-30 minute",
      garantie: "Certificat ITP pentru motociclete"
    },
    {
      id: 4,
      icon: <FaTruckFront />,
      title: "ITP Vehicule Utilitare",
      subtitle: "Soluții pentru transport comercial",
      description: "Verificări specializate pentru vehicule utilitare, camioane și autobuze, respectând normele pentru transport comercial.",
      details: [
        "Verificarea sistemului de frânare pentru vehicule grele",
        "Controlul sistemului pneumatic și hidraulic",
        "Testarea tahografului și limitatorului de viteză",
        "Verificarea sistemelor de încărcare și descărcare",
        "Controlul documentelor ADR (transport mărfuri periculoase)",
        "Verificarea sistemelor de siguranță pentru pasageri",
        "Testarea sistemelor de iluminat pentru vehicule mari",
        "Controlul emisiilor pentru motoare diesel"
      ],
      durata: "45-60 minute",
      garantie: "Certificat ITP + documentație specifică"
    },
    {
      id: 5,
      icon: <FaCompressAlt />,
      title: "Re-ITP",
      subtitle: "Verificare după remedieri",
      description: "Serviciu de re-verificare pentru vehiculele respinse la prima inspecție, după efectuarea reparațiilor necesare.",
      details: [
        "Verificarea punctelor semnalate în prima inspecție",
        "Controlul reparațiilor efectuate",
        "Testarea componentelor înlocuite",
        "Verificare finală completă",
        "Emiterea certificatului ITP la conformitate"
      ],
      durata: "15-25 minute",
      garantie: "Certificat ITP final"
    },
    {
      id: 6,
      icon: <IoDocumentTextOutline />,
      title: "Verificări Tehnice Speciale",
      subtitle: "Servicii suplimentare",
      description: "Efectuăm verificări tehnice pentru situații speciale: vehicule modificate, import, înmatriculări speciale.",
      details: [
        "Verificări pentru vehicule modificate tehnic",
        "Inspecții pentru vehicule de import",
        "Verificări pentru vehicule istorice",
        "Controlul conformității modificărilor",
        "Verificări pentru înmatriculări temporare",
        "Inspecții pentru vehicule de colecție"
      ],
      durata: "Variabilă",
      garantie: "Raport tehnic detaliat"
    }
  ];

  const avantaje = [
    {
      icon: <AiFillThunderbolt />,
      title: "Rapiditate",
      description: "Programări flexibile și timpi de așteptare reduși"
    },
    {
      icon: <FaCheckCircle />,
      title: "Profesionalisme",
      description: "Personal certificat RAR cu experiență vastă"
    },
    {
      icon: <TbTarget />,
      title: "Precizie",
      description: "Echipamente moderne de ultimă generație"
    },
    {
      icon: <FaRegLightbulb />,
      title: "Transparență",
      description: "Explicații clare despre toate verificările efectuate"
    }
  ];

  return (
    <div className="servicii-container">
      <Navbar />

<Helmet>
  {/* Meta tags principale */}
  <title>Servicii ITP București Sector 2 | Inspecție Tehnică Periodică Completă</title>
  <meta 
    name="description" 
    content="Servicii ITP complete în București Sector 2: autoturisme, motociclete, utilitare. Personal certificat RAR, echipamente moderne. Program: Luni-Vineri 09:00-19:30, Sâmbătă 08:00-13:30. ☎️ +40726104358" 
  />
  <meta 
    name="keywords" 
    content="ITP București Sector 2, inspecție tehnică periodică, ITP autoturisme, ITP motociclete, ITP utilitare, Re-ITP, stație ITP autorizată RAR, verificări tehnice auto, emisii poluante, Șoseaua Electricității 26" 
  />
  
  {/* Canonical URL */}
  <link rel="canonical" href="https://itp-sector2.ro/servicii" />
  
  {/* Open Graph pentru Facebook */}
  <meta property="og:title" content="Servicii ITP Complete București Sector 2 | Stație Autorizată RAR" />
  <meta property="og:description" content="Inspecție tehnică periodică pentru toate tipurile de vehicule. 15+ ani experiență, 50k+ vehicule verificate, 95% rată promovabilitate." />
  <meta property="og:url" content="https://itp-sector2.ro/servicii" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://itp-sector2.ro/images/servicii-itp-sector2.jpg" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta property="og:image:alt" content="Servicii ITP complete la stația autorizată din Sectorul 2" />
  <meta property="og:site_name" content="ITP Sector 2" />
  <meta property="og:locale" content="ro_RO" />
  
  {/* Twitter Cards */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Servicii ITP București Sector 2 | Stație Autorizată" />
  <meta name="twitter:description" content="ITP pentru autoturisme, motociclete, utilitare. Personal certificat RAR, echipamente moderne. Program Luni-Sâmbătă." />
  <meta name="twitter:image" content="https://itp-sector2.ro/images/servicii-itp-sector2.jpg" />
  <meta name="twitter:image:alt" content="Servicii ITP Sector 2 București" />
  
  {/* Meta tags pentru local business */}
  <meta name="geo.region" content="RO-B" />
  <meta name="geo.placename" content="București, Sector 2" />
  <meta name="geo.position" content="44.451639;26.133095" />
  <meta name="ICBM" content="44.451639, 26.133095" />
  
  {/* Informații pentru motoare de căutare */}
  <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
  <meta name="author" content="ITP Sector 2" />
  <meta name="publisher" content="ITP Sector 2" />
  <meta name="revisit-after" content="7 days" />
  <meta name="language" content="Romanian" />
  <meta name="distribution" content="global" />
  <meta name="rating" content="general" />
  
  {/* Meta tags mobile */}
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
  <meta name="format-detection" content="telephone=yes" />
  <meta name="mobile-web-app-capable" content="yes" />
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
  <meta name="apple-mobile-web-app-title" content="ITP Sector 2" />
  
  {/* Structured Data JSON-LD pentru servicii */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AutoRepair", 
      "name": "ITP Sector 2",
      "description": "Stație ITP autorizată în București Sector 2, oferind servicii complete de inspecție tehnică periodică pentru toate tipurile de vehicule.",
      "url": "https://itp-sector2.ro/servicii",
      "logo": "https://itp-sector2.ro/logo.png",
      "image": "https://itp-sector2.ro/images/statia-itp-sector2.jpg",
      
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Șoseaua Electricității nr. 26",
        "addressLocality": "București",
        "addressRegion": "Sector 2", 
        "postalCode": "021652",
        "addressCountry": "RO"
      },
      
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "44.451639",
        "longitude": "26.133095"
      },
      
      "telephone": "+40726104358",
      "email": "contact@itp-sector2.ro",
      
      "openingHours": [
        "Mo 09:00-19:30",
        "Tu 09:00-19:30",
        "We 09:00-19:30", 
        "Th 09:00-19:30",
        "Fr 09:00-19:30",
        "Sa 08:00-13:30"
      ],
      
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday", 
          "opens": "08:00",
          "closes": "13:30"
        }
      ],
      
      "priceRange": "$$",
      "currenciesAccepted": "RON",
      "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer"],
      
      "areaServed": [
        {
          "@type": "Place",
          "name": "București Sector 2"
        },
        {
          "@type": "Place", 
          "name": "București"
        }
      ],
      
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicii ITP Complete",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "ITP Autoturisme",
              "description": "Inspecție tehnică periodică pentru mașini personale, verificare completă conform normelor RAR",
              "provider": {
                "@type": "AutoRepair",
                "name": "ITP Sector 2"
              }
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Service",
              "name": "ITP Motociclete & ATV",
              "description": "Servicii specializate pentru motociclete, scutere și ATV-uri cu personal specializat",
              "provider": {
                "@type": "AutoRepair",
                "name": "ITP Sector 2"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "ITP Vehicule Utilitare",
              "description": "Verificări specializate pentru vehicule utilitare, camioane și autobuze",
              "provider": {
                "@type": "AutoRepair",
                "name": "ITP Sector 2"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Re-ITP",
              "description": "Serviciu de re-verificare după remedieri pentru vehiculele respinse",
              "provider": {
                "@type": "AutoRepair", 
                "name": "ITP Sector 2"
              }
            }
          }
        ]
      },
      
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8", 
        "reviewCount": "247",
        "bestRating": "5",
        "worstRating": "1"
      },
      
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Alexandru M."
          },
          "reviewRating": {
            "@type": "Rating", 
            "ratingValue": "5",
            "bestRating": "5"
          },
          "reviewBody": "Servicii excelente, personal profesionist și timpi de așteptare scurți. Recomand cu încredere!"
        }
      ],
      
      "makesOffer": [
        {
          "@type": "Offer",
          "name": "ITP Standard",
          "description": "Inspecție tehnică periodică completă",
          "priceCurrency": "RON",
          "availability": "InStock"
        }
      ],
      
      "sameAs": [
        "https://www.instagram.com/itp_auto_moto?igsh=d2x6OTdrNndkbXZq&utm_source=qr",
        "https://www.facebook.com/itp.sector2",
        "https://itp-sector2.ro"
      ],
      
      "slogan": "15+ ani experiență, 50k+ vehicule verificate, 95% rată de promovabilitate",
      
      "knowsAbout": [
        "Inspecție tehnică periodică",
        "Verificări auto",
        "Emisii poluante", 
        "Sistem frânare",
        "Direcție și suspensie",
        "RAR autorizare",
        "Re-ITP",
        "Vehicule utilitare",
        "Motociclete"
      ]
    })}
  </script>
  
  {/* FAQ Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Ce servicii ITP oferă stația voastră?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Oferim servicii complete de ITP pentru autoturisme, motociclete, ATV-uri, vehicule utilitare, Re-ITP și verificări tehnice speciale. Avem personal certificat RAR și echipamente moderne pentru toate tipurile de vehicule."
          }
        },
        {
          "@type": "Question", 
          "name": "Cât durează o inspecție ITP?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Durata variază în funcție de tipul vehiculului: 20-30 minute pentru motociclete, 30-45 minute pentru autoturisme, 45-60 minute pentru vehicule utilitare și 15-25 minute pentru Re-ITP."
          }
        },
        {
          "@type": "Question",
          "name": "Care este programul stației ITP?", 
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Programul nostru: Luni-Vineri 09:00-19:30, Sâmbătă 08:00-13:30, Duminică închis. Pentru programări sunați la +40726104358."
          }
        },
        {
          "@type": "Question",
          "name": "Unde vă aflați?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ne găsiți la adresa Șoseaua Electricității nr. 26, București, Sector 2. Stația este ușor accesibilă și dispune de parcare."
          } 
        },
        {
          "@type": "Question",
          "name": "Aveți autorizație RAR?",
          "acceptedAnswer": {
            "@type": "Answer", 
            "text": "Da, suntem autorizați RAR cu nr. ITP-ST-025/2024 și avem peste 15 ani experiență în domeniu cu o rată de promovabilitate de 95%."
          }
        }
      ]
    })}
  </script>
  
  {/* Breadcrumb Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org", 
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Acasă",
          "item": "https://itp-sector2.ro"
        },
        {
          "@type": "ListItem",
          "position": 2, 
          "name": "Servicii ITP",
          "item": "https://itp-sector2.ro/servicii"
        }
      ]
    })}
  </script>
</Helmet>
      
      <div className="servicii-content">
        {/* Hero Section */}
        <section className="hero-section">
          <div data-aos="fade-left" data-aos-duration="3500" className="hero-content">
            <h1>Servicii ITP Complete</h1>
            <p>Stația ITP Sector 2 oferă servicii profesionale de inspecție tehnică pentru toate tipurile de vehicule, cu echipamente moderne și personal certificat RAR.</p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">15+</span>
                <span className="stat-label">Ani experiență</span>
              </div>
              <div className="stat">
                <span className="stat-number">50k+</span>
                <span className="stat-label">Vehicule verificate</span>
              </div>
              <div className="stat">
                <span className="stat-number">95%</span>
                <span className="stat-label">Rata de promovabilitate</span>
              </div>
            </div>
          </div>
          <div data-aos="fade-left" data-aos-duration="3500" className="hero-visual">
            <div className="floating-card">
              <div className="card-icon">🏆</div>
              <div className="card-content">
                <h3>Autorizația RAR</h3>
                <p>Nr. ITP-ST-025/2024</p>
              </div>
            </div>
          </div>
        </section>

        <section data-aos="fade-left" data-aos-duration="3500" className="itp-section">
      <div className="itp-container">
        <h2 data-aos="fade-left" data-aos-duration="3500" className="itp-title">Ce presupune o verificare ITP?</h2>
        <ul className="itp-list">
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Verificarea sistemului de frânare</strong></li>
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Testarea sistemului de direcție și suspensie</strong></li>
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Verificarea sistemelor de iluminare și semnalizare</strong></li>
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Măsurarea nivelului de emisii poluante</strong></li>
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Identificarea vehiculului (serie șasiu, documente)</strong></li>
          <li data-aos="fade-left" data-aos-duration="3500"><strong>Verificarea sistemului de evacuare</strong></li>
        </ul>
      </div>
    </section>

        {/* Servicii Principale */}
        <section data-aos="fade-left" data-aos-duration="3500" className="servicii-section">
          <div className="section-header">
            <h2>Serviciile Noastre</h2>
            <p>Oferim o gamă completă de servicii ITP, adaptate nevoilor fiecărui tip de vehicul</p>
          </div>

          <div className="servicii-grid">
            {servicii.map((serviciu) => (
              <div 
                key={serviciu.id} 
                className={`serviciu-card ${activeService === serviciu.id ? 'active' : ''}`}
                onClick={() => setActiveService(activeService === serviciu.id ? null : serviciu.id)}
              >
                <div data-aos="fade-left" data-aos-duration="3500" className="serviciu-header">
                  <div data-aos="fade-left" data-aos-duration="3500" className="serviciu-icon">{serviciu.icon}</div>
                  <div data-aos="fade-left" data-aos-duration="3500" className="serviciu-title">
                    <h3 data-aos="fade-left" data-aos-duration="3500">{serviciu.title}</h3>
                    <p data-aos="fade-left" data-aos-duration="3500">{serviciu.subtitle}</p>
                  </div>
                  <div data-aos="fade-left" data-aos-duration="3500" className="expand-icon">
                    {activeService === serviciu.id ? '−' : '+'}
                  </div>
                </div>
                
                <div className="serviciu-content">
                  <p className="serviciu-description">{serviciu.description}</p>
                </div>

                {activeService === serviciu.id && (
                  <div className="serviciu-details">
                    <div className="details-content">
                      <h4>Ce verificăm:</h4>
                      <ul className="details-list">
                        {serviciu.details.map((detail, index) => (
                          <li key={index}>{detail}</li>
                        ))}
                      </ul>
                      
                      <div className="serviciu-meta">
                        <div className="meta-item">
                          <span className="meta-label">Durată estimată:</span>
                          <span className="meta-value">{serviciu.durata}</span>
                        </div>
                        <div className="meta-item">
                          <span className="meta-label">La finalizare:</span>
                          <span className="meta-value">{serviciu.garantie}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Avantajele Noastre */}
        <section data-aos="fade-left" data-aos-duration="3500" className="avantaje-section">
          <h2>De ce să alegi stația noastră ITP?</h2>
          <div className="avantaje-grid">
            {avantaje.map((avantaj, index) => (
              <div key={index} className="avantaj-card">
                <div className="avantaj-icon">{avantaj.icon}</div>
                <h3>{avantaj.title}</h3>
                <p>{avantaj.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Procesul ITP */}
        <section data-aos="fade-left" data-aos-duration="3500" className="proces-section">
          <div className="proces-content">
            <div className="proces-text">
              <h2>Cum funcționează procesul ITP?</h2>
              <div className="proces-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Programarea</h4>
                    <p>Sună pentru a programa o întâlnire sau vine direct în program</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Verificarea documentelor</h4>
                    <p>Prezentarea actelor necesare și verificarea datelor vehiculului</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Inspecția tehnică</h4>
                    <p>Verificarea completă a vehiculului conform normelor în vigoare</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Rezultatul</h4>
                    <p>Primirea certificatului ITP sau a listei cu defecțiunile de remediat</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="proces-visual">
              <div className="timeline">
                <div className="timeline-item active">
                  <div className="timeline-dot"></div>
                  <span>Start</span>
                </div>
                <div className="timeline-item active">
                  <div className="timeline-dot"></div>
                  <span>Documente</span>
                </div>
                <div className="timeline-item active">
                  <div className="timeline-dot"></div>
                  <span>Verificare</span>
                </div>
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <span>Certificat</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Servicii;